import apiClient from "utils/apiClient";


export async function fetchAdminDashboardStats() {
  const { data } = await apiClient.get("/ovizia-service/api/v1/admin/dashboard/stats");
  return data;
}

export async function fetchAdminDashboardAlerts() {
  const { data } = await apiClient.get("/ovizia-service/api/v1/admin/dashboard/alerts");
  return data;
}